import { AxiosResponse } from 'axios';
import clientRetryable from './clientRetryable';
import clientLoggable from './clientLoggable';
import PhotoType from '@/resources/enum/PhotoType';
import getAuthHeader from '@/util/getAuthHeader';

export default {
  async location(
    request: RequestLocation,
    mockAdditional?: RequestLocationMockAdditional
  ): Promise<AxiosResponse<ResponseLocation>> {
    const response: AxiosResponse<ResponseLocation> = await clientRetryable.post<ResponseLocation>(
      'id_doc_photos',
      process.env.VUE_APP_API_MODE === 'mock' ? Object.assign({}, request, mockAdditional) : request,
      { headers: getAuthHeader() }
    );
    return response;
  },

  async autoDetect(idDocPhotoID: number, request: RequestAutoDetect): Promise<AxiosResponse<ResponseAutoDetect>> {
    const response: AxiosResponse<ResponseAutoDetect> = await clientLoggable.put<ResponseAutoDetect>(
      `id_doc_photos/${idDocPhotoID}/check_image`,
      request,
      { headers: getAuthHeader() }
    );
    return response;
  },

  async upload(idDocPhotoID: number, request: RequestUpload): Promise<AxiosResponse<void>> {
    const response: AxiosResponse<void> = await clientRetryable.post<void>(
      `id_doc_photos/${idDocPhotoID}/images`,
      request,
      { headers: getAuthHeader() }
    );
    return response;
  },

  async images(idDocPhotoID: number): Promise<AxiosResponse<ResponseImages>> {
    const response: AxiosResponse<ResponseImages> = await clientRetryable.get<ResponseImages>(
      `id_doc_photos/${idDocPhotoID}/trimmed_images`,
      { headers: getAuthHeader() }
    );
    return response;
  },

  async confirm(idDocPhotoID: number): Promise<AxiosResponse<void>> {
    const response: AxiosResponse<void> = await clientRetryable.put<void>(
      `id_doc_photos/${idDocPhotoID}/update_confirmed_result`,
      null,
      { headers: getAuthHeader() }
    );
    return response;
  }
};

export interface RequestLocation {
  photo_type: PhotoType;
  photo: {
    width: number;
    height: number;
  };
  display: {
    width: number;
    height: number;
  };
  header: {
    width: number;
    height: number;
  };
  footer: {
    width: number;
    height: number;
  };
}

export interface RequestLocationMockAdditional {
  card?: {
    width: number;
    height: number;
  };
  forceCenter?: boolean;
}

export interface ResponseLocation {
  positionY: number;
  idDocPhotoID: number;
}

export interface RequestAutoDetect {
  imageBase64: string;
}

export interface ResponseAutoDetect {
  isValid: boolean;
  cvResults: {
    name: string;
    result: boolean;
  }[];
}

export interface RequestUpload {
  imageBase64: string;
  isAutoShoot: boolean;
}

export interface ResponseImages {
  trimmedImageBase64: string;
}
